<template>
    <div id="app" style="height: 100%; width: 100%">
        <GeneratePdfLoader style="z-index: 2000"></GeneratePdfLoader>
        <ReportLoader style="z-index: 2000"></ReportLoader>
        <PreLoader style="z-index: 2000"></PreLoader>
        <router-view />
    </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import SessionService from './api/services/session.service'
import PreLoader from './components/loaders/PreLoader.vue'
import ReportLoader from './components/loaders/ReportLoader.vue'
import GeneratePdfLoader from './components/loaders/GeneratePdfLoader.vue'
import globalModule from './store/modules/global.module'

@Component({
    components: {
        PreLoader,
        ReportLoader,
        GeneratePdfLoader,
    },
})
export default class App extends Vue {
    async mounted() {
        console.log('mounted app')
        if (localStorage.getItem('token')) {
            await SessionService.getSession()
        } else {
            globalModule.updateLoading(false)
            globalModule.setRouter('/login')
        }
    }
}
</script>

<style lang="scss">
@font-face {
    font-family: 'Changa';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('@/assets/fonts/changa-latin.woff2') format('woff2'),
        url('@/assets/fonts/changa-latin-ext.woff2') format('woff2');
}

body {
    user-select: none;
}

* {
    font-family: 'Changa', Avenir, Helvetica, Arial, sans-serif !important;
}

#app {
    font-family: 'Changa', Avenir, Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

p {
    font-family: 'Changa', sans-serif !important;
    font-weight: 400 !important;
}

nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;
    }
}
</style>
